module.exports = __webpack_public_path__ + "img/activity_btn.766b2f82.gif";